export default "__VITE_ASSET__2i225JUo__"